module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei4.svg";